<template>
  <router-view name="blog" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Blog",
};
</script>
